/**
 * These option arrays are used in the following components:
 * - web/app/components/lgc/consultation-report-form/crohn-form.gts
 * - web/app/components/lgc/consultation-report-form/rch-form.gts
 */

// Options for both Crohn and RCH forms
export const overallFeelingOptions = [
  "Bon",
  "Moyen",
  "Médiocre",
  "Mauvais",
  "Très mauvais"
] as const;

// Options for both Crohn and RCH
export const abdominalPainOptions = [
  "Absente",
  "Faible",
  "Moyenne",
  "Intense"
] as const;
export const articularOptions = [
  "Arthralgies périphérique type 1 (parallèle à la MICI)",
  "Arthralgies périphérique type 2 (indépendant à la MICI)",
  "Rhumatisme axial"
] as const;
export const skinLesionsOptions = [
  "Pyoderma",
  "Erythème noueux",
  "Dermatose neutrophilique"
] as const;
export const oralLesionsOptions = [
  "Aphthose (au moins 3 aphtes)",
  "Stomatite attribuable à la MICI"
] as const;
export const ophtalmicSymptomsOptions = [
  "Uvéite",
  "Kératite",
  "Conjonctivite"
] as const;

// Options specific to Crohn form
export const abdominalMassOptions = [
  "Aucune",
  "Douteuse",
  "Certaine",
  "Douloureuse"
] as const;

// Options specific to RCH form
export const rectalBleedingOptions = [
  "Absent",
  "<50% des émissions",
  ">50% des émissions",
  "100% des émissions"
] as const;

// Options specific to RCH form
export const defecateEmergencyOptions = [
  "Aucune",
  "Pressée",
  "Immédiate",
  "Incontinence"
] as const;

// Options specific to RCH form
export const activityOverwallFeelingOptions = [
  "Quiescente",
  "Activité légère",
  "Activité modérée",
  "Maladie sévère"
] as const;

// Options specific to RCH form
export const diseaseActivityStringOptions = [
  "Quiescente",
  "Minime",
  "Modérée",
  "Sévère",
  "Grave"
] as const;
